var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { useContext } from "react";
import { EntityTypeIconsContext, EntityTypeIconsSetDefault } from "../components/context/entity-type-icons-context";
export function useEntityTypeIcons() {
  var provided = useContext(EntityTypeIconsContext) || {};
  return __assign(__assign({}, EntityTypeIconsSetDefault), provided);
}
;
export function useEntityTypeIcon(entityTypeName) {
  var components = useEntityTypeIcons(); // @ts-ignore

  return components[entityTypeName] || components['Entity'];
}
;